/**
 * Definizioni di categorie di eventi con campi standard
 * Questo file contiene tutte le configurazioni di categoria per gli eventi UISP
 * Centralizzare queste definizioni permette di:
 * 1. Evitare duplicazioni di codice
 * 2. Garantire coerenza tra form di creazione e modifica
 * 3. Semplificare manutenzione e aggiornamenti futuri
 */

// Esporta la lista delle categorie disponibili con i loro campi di default
export const categoryOptions = [
  {
    value: 'danza',
    label: 'Danza',
    defaultFields: [
      {
        fieldName: 'style',
        fieldLabel: 'Stile',
        fieldType: 'select',
        isRequired: true,
        options: [
          'Danza Classica (Classico, Neoclassico, Danza di Carattere)',
          'Danza Moderna/Jazz (Modern, Modern Jazz, Lyrical Jazz)',
          'Danza Contemporanea',
          'Street Dance e Urban (Hip Hop, Break Dance, Funk, Hype, Elektric Boogie, Contaminazioni urbane, Jumpstyle)',
          'Danze Jazz Internazionali (Boogie Woogie, Lindy Hop, Rock n Roll, Rock Acrobatico, Swing Dance, Mixing Blues, Tap Dance)',
          'Danze Internazionali (Danze caraibiche, Danze argentine, Hustle)',
          'Danze Standard e Latine (Valzer Inglese, Tango, Valzer Viennese, Slow Foxtrot, Quick Step, Samba, Cha Cha Cha, Rumba, Paso Doble, Jive)',
          'Danze Nazionali e Folk (Liscio Unificato, Liscio Tradizionale, Danze Popolari, Mazurka, Valzer, Polka, Danze folkloristiche regionali)',
          'Danze di Fantasia'
        ]
      },
      {
        fieldName: 'ageBand',
        fieldLabel: "Categoria / Fascia d'età",
        fieldType: 'select',
        isRequired: true,
        enforceAgeRules: true,
        options: [
          { value: 'Esibizione (3-5 anni)', minAge: 3, maxAge: 5, maxOutOfQuota: 2 },
          { value: 'Predanza 1 (4-6 anni)', minAge: 4, maxAge: 6, maxOutOfQuota: 2 },
          { value: 'Predanza 2 (6-8 anni)', minAge: 6, maxAge: 8, maxOutOfQuota: 2 },
          { value: 'Predanza 3 (8-10 anni)', minAge: 8, maxAge: 10, maxOutOfQuota: 2 },
          { value: 'Allievi (10-12 anni)', minAge: 10, maxAge: 12, maxOutOfQuota: 2 },
          { value: 'Junior (12-14 anni)', minAge: 12, maxAge: 14, maxOutOfQuota: 2 },
          { value: 'Senior (15-17 anni)', minAge: 15, maxAge: 17, maxOutOfQuota: 2 },
          { value: 'Over (18-30 anni)', minAge: 18, maxAge: 30, maxOutOfQuota: 2 }
        ]
      },
      {
        fieldName: 'category',
        fieldLabel: 'Categoria (Configurazione)',
        fieldType: 'select',
        isRequired: true,
        options: [
          'Solisti',
          'Duo/Passo a due',
          'Gruppi (minimo tre partecipanti)'
        ]
      },
      {
        fieldName: 'choreographyTitle',
        fieldLabel: 'Titolo coreografia',
        fieldType: 'text',
        isRequired: true
      },
      {
        fieldName: 'choreographyDuration',
        fieldLabel: 'Durata coreografia/tempo',
        fieldType: 'text',
        isRequired: true
      },
      {
        fieldName: 'audioFile',
        fieldLabel: 'File audio',
        fieldType: 'audio',
        isRequired: true
      }
    ]
  },
  {
    value: 'manifestazione',
    label: 'Manifestazione',
    defaultFields: [
      {
        fieldName: 'athleteName',
        fieldLabel: 'Nome Atleta',
        fieldType: 'text',
        isRequired: true
      }
    ]
  },
  { value: 'corso', label: 'Corso', defaultFields: [] },
  { value: 'altro', label: 'Altro', defaultFields: [] }
];

/**
 * Funzione per verificare se un campo è predefinito di sistema
 * @param {string} fieldName - Nome del campo da verificare
 * @returns {boolean} - true se il campo è predefinito di sistema
 */
export const isSystemDefinedField = (fieldName) => {
  return categoryOptions.some(cat =>
    cat.defaultFields.some(df => df.fieldName === fieldName)
  );
};

/**
 * Ottieni i campi predefiniti per una categoria specifica
 * @param {string} categoryValue - Il valore della categoria (es. 'danza')
 * @returns {Array} - Array di campi predefiniti per la categoria o array vuoto
 */
export const getDefaultFieldsForCategory = (categoryValue) => {
  const category = categoryOptions.find(cat => cat.value === categoryValue);
  return category ? [...category.defaultFields] : [];
};
